import { useState } from 'react';

import { useRiskRegisterStore } from 'store/riskRegister.store';

import { useQueryRiskDrivers } from 'api/queries/riskDrivers.query';

import { impactTypeOptions } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.utils';

export type UseRiskDriversProvider = ReturnType<typeof useRiskDriversProvider>;

export const useRiskDriversProvider = ({ latestVersionId, endpoint }) => {
    const { numOfIterations, riskIds, taskVersionHashCode, runQsra } = useRiskRegisterStore();
    const [impactType, setImpactType] = useState<ISelectOption<'DAYS' | 'CORRELATION'>>(impactTypeOptions[0]);

    return {
        ui: {
            state: {
                impactType,
            },
            setters: {
                setImpactType,
            },
        },
        api: {
            riskDrivers: useQueryRiskDrivers(
                {
                    riskIds,
                    taskVersionHashCode,
                    numOfIterations,
                    metaDataId: latestVersionId,
                    runQsra,
                },
                endpoint,
            ),
        },
    };
};
